// src/com/veh_info/VehInfoSelectDialog.js
import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/system';
//import { styled } from '@mui/material/styles';
import {
    Dialog, DialogContent, Slide, Button,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { AppStyle } from '../../value/AppConst';
import SearchBox from '../../common/SearchBox';
import { ControlLine, DialogHeader } from '../../common/TopStyle';
import VehInfoLine from './VehInfoLine';
import IsValid from '../../value/IsValid';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const filterByText = (item, text) => {
    if(!text) return true;
    const searchText = text.trim().toLowerCase();
    if(!IsValid.text(text)) return true;

    if(item.vehPlates && item.vehPlates.toLowerCase().includes(searchText)) return true;
    if(item.driverName && item.driverName.toLowerCase().includes(searchText)) return true;
    if(item.driverMobile && item.driverMobile.toLowerCase().includes(searchText)) return true;
    return false;
};

/**
 * 차량선택용 다이얼로그
 * @param {*} param0 
 * @returns 
 */
export default function VehInfoSelectDialog({
    open,
    onClose,
    records,
    onSelect, // vehInfo object
    comInfoList,
    defaultSearchText = '',
}) {
    const [filtered, setFiltered] = useState([]);
    // const [comId, setComId] = useState(null);
    const [countToDisplay, setCountToDisplay] = useState(0);
    const [selected, setSelected] = useState(null); // for itemSelected
    const [searchText, setSearchText] = useState(defaultSearchText);
    const [sortInfo, setSortInfo] = useState({id: null, order: 0}); // -1 : descending, 0: no sorting, 1: ascending
    const comNameNow = useMemo(() => {
        if(records.length >0) {
            const comId = records[0].comId;
            const comInfo = comInfoList.find((item) => item.comId === comId);
            if(comInfo) return comInfo.comName;
        }
        return '[없음]';
    }, [records, comInfoList]);
    /* const comList = useMemo(() => {
        const list = comInfoList.map((com) => {
            if(com.comId === AppWord.ChooseValue) {
                return {
                    comId: AppWord.ChooseValue,
                    comName: '전체',
                };
            }
            return com;
        });
        return list;
    }, [comInfoList]); */

    useEffect(() => {
        if(open && records) {
            // let list = comId ? records.filter((item) => item.comId === comId) : records;
            let fr = records.filter((item) => filterByText(item, searchText));

            if(sortInfo.id && sortInfo.order !== 0) {
                const sorted = [...fr].sort((a, b) => {
                    const orderBy = sortInfo.order < 0 ? -1 : 1; // -1: descending, 1: ascending
                    if(a[sortInfo.id] < b[sortInfo.id]) return -1 * orderBy;
                    if(a[sortInfo.id] > b[sortInfo.id]) return orderBy;
                    return 0;
                });
                
                fr = sorted;
            }
            setFiltered(fr);
            setCountToDisplay(fr.length);
        }
    }, [open, records, searchText, sortInfo]);

    /* const onChangeCom = (id, value) => {
        // onChangeValue(id, value === AppWord.ChooseValue ? undefined : value, false);
        setComId(value === AppWord.ChooseValue ? null : value);
    }; */

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const onClickSorter = (id, sortState) => {
        setSortInfo({id, order: sortState});
    };

    const renderBody = () => {
        return(
            <div style={{
                    flexGrow:1, display:'flex', flexDirection:'column'
                }}
            >
                <ControlLine style={{paddingTop: '1rem'}}>
                    <span style={{marginRight: 10, fontSize:'0.8rem', color: AppStyle.PrimaryRGB}}>운송사</span>
                    <span>
                        {comNameNow}
                    </span>
                    {/* <VzmSelector
                        dict={TransPlanLaunchDictionary.inputMap.comId}
                        value={comId || AppWord.ChooseValue}
                        onChange={onChangeCom}
                        list={comList}
                        fullWidth={true}
                        variant={AppStyle.mui.standard}
                    /> */}
                </ControlLine>
                <ControlLine>
                    <SearchBox
                        value={searchText}
                        onChangeText={onChangeSearchText}
                        width={160}
                    />
                    <Box style={{flexGrow:1, textAlign:'right'}}>
                        {
                            selected ?
                            <Button
                                variant={AppStyle.mui.contained}
                                color={AppStyle.mui.primary}
                                disabled={!selected}
                                startIcon={<CheckIcon />}
                                onClick={()=>{
                                    if(selected) onSelect(selected);
                                    else onClose();
                                }}
                            >
                                {selected.vehPlates} 선택
                            </Button>
                            :
                            <span>차량을 선택하세요</span>
                        }
                    </Box>
                </ControlLine>
                <div>
                    <VehInfoLine
                        onClickSorter={onClickSorter}
                        idSorted={sortInfo.id}
                    />
                </div>
                <div style={{flexGrow:1, overflowY:'auto'}}>
                    {
                        filtered.map((item, index) => {
                            return(
                                <VehInfoLine
                                    key={item.vehInfoSeq}
                                    item={item}
                                    index={index}
                                    itemSelected={selected}
                                    onClick={(newSelected)=>setSelected(newSelected)}
                                />
                            );
                        })
                    }
                </div>
            </div>
        );
    };

    return(
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            slots={{transition: Transition}}
        >
            <DialogHeader
                title={"차량 선택" + (countToDisplay > 0 ? ` (총${countToDisplay})` : '')}
                onClickClose={onClose}
            />
            <DialogContent style={{display:'flex', padding: 0,}}>
                <div style={{width:1}}></div>
                {renderBody()}
                <div style={{width:1}}></div>
            </DialogContent>
        </Dialog>
    );
}